import React from 'react';
import {
  makeResetStyles,
  shorthands,
  mergeClasses,
} from '@fluentui/react-components';

const useLoadingViewStyles = makeResetStyles({
  width: '100%',
  ...shorthands.borderRadius('2px'),
  height: '4px',
  background: 'linear-gradient(to right, rgba(0, 120, 212, 0) 0%, #213AD5 50%, rgba(0, 120, 212, 0) 100%)',
  backgroundSize: '33%',
  backgroundRepeat: 'no-repeat',
  animation: 'loading_indicator 3s linear infinite',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
  animationDuration: '3s',
  animationName: [{
    from: { backgroundPosition: '-50%' },
    to: { backgroundPosition: '150%' },
  }],
  backgroundColor: '#E6E6E6',
  forcedColorAdjust: 'none',
});

export const LoadingIndicator = () => {
  const loadingViewStyles = useLoadingViewStyles();
  return (
    <div className={mergeClasses('loading-indicator', loadingViewStyles)} />
  );
};
